import { AIStudioLogo } from '@repo/studio-design-system-ui-ai-studio-logo'
import { AIStudioVisualMark } from '@repo/studio-design-system-ui-ai-studio-logo/visual-mark'

export function DesktopBrand() {
  return (
    <span className="inline-flex items-center gap-2.5" aria-label="idea.ai">
      <AIStudioVisualMark className="size-8 text-studio-orange-400" />
      <AIStudioLogo className="h-6 w-auto text-theme_semantic_surface_ui_foreground-color-strong" />
    </span>
  )
}
